module.exports = __webpack_public_path__ + "img/icon-1-ed93d512.svg";